module.exports = __webpack_public_path__ + "../resources/img/pictogram_batt_inven.f5f52dd7.png";